import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { registerUiKitI18n } from '@vedmarket/ui-kit';

import enDictionary from '../assets/dictionaries/en.json';
import ruDictionary from '../assets/dictionaries/ru.json';

const enum LOCALES {
  ENGLISH = 'en',
  RUSSIAN = 'ru',
}

const resources = {
  [LOCALES.ENGLISH]: { translation: enDictionary },
  [LOCALES.RUSSIAN]: { translation: ruDictionary },
};

export const supportedLngs = {
  ru: 'Русский',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: Object.keys(supportedLngs),
    fallbackLng: LOCALES.RUSSIAN,
    interpolation: {
      escapeValue: false,
    },
  });

registerUiKitI18n(i18n);

export default i18n;
